import { jwtDecode } from 'jwt-decode'
import { getAccessToken, clearSavedTokens } from '../services/authentication'

interface SwileJwtPayload {
  sub: string // account UUID
  email: string
  banking_account_uuid?: string
  sudoer_uid?: string
  sudoer_email?: string
  scope?: string
  exp: number
}

interface CurrentUser {
  uuid: string
  email: string
  bankingAccountUuid?: string
  sudoerUid?: string
  sudoerEmail?: string
}

export const useCurrentUser = (): CurrentUser | undefined => {
  try {
    const accessToken = getAccessToken()

    if (!accessToken) {
      return undefined
    }

    const decoded = jwtDecode<SwileJwtPayload>(accessToken)

    return {
      uuid: decoded.sub,
      email: decoded.email,
      bankingAccountUuid: decoded.banking_account_uuid,
      sudoerUid: decoded.sudoer_uid,
      sudoerEmail: decoded.sudoer_email,
    }
  } catch (_error) {
    clearSavedTokens()
    return undefined
  }
}
